<template>
  <div class="container">
    <div class="fixed-header">
      <van-nav-bar title="我的信息" left-text="返回" left-arrow @click-left="onClickLeft" class="custom-nav-bar" />
    </div>
    <div class="content-section">
      <van-cell-group class="info-card">
        <van-field v-model="bowlerInfo.name" :required="isEditMode" label="姓名" :placeholder="isEditMode ? '请输入用户名' : ''"
          :readonly="!isEditMode" />

        <van-field v-model="bowlerInfo.mobilePhone" type="tel" :required="isEditMode" label="手机"
          :placeholder="isEditMode ? '请输入手机号' : ''" :readonly="!isEditMode" />

        <van-field v-if="!isEditMode" v-model="enums.gender[bowlerInfo.gender]" :required="isEditMode" label="性别"
          :readonly="!isEditMode" />
        <van-field v-if="isEditMode" label="性别" :required="isEditMode">
          <template #input>
            <van-radio-group v-model="gender" direction="horizontal">
              <van-radio name="0">男</van-radio>
              <van-radio name="1">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>


        <van-field v-model="bowlerInfo.birthDate" readonly :clickable="isEditMode" label="生日"
          :placeholder="isEditMode ? '点击选择生日' : ''" @click="isEditMode && (showBirthDatePicker = true)" />

        <van-field v-if="!isEditMode" v-model="enums.leftRightHand[bowlerInfo.leftRightHand]" :required="isEditMode"
          label="左右手" :readonly="!isEditMode" />
        <van-field v-if="isEditMode" label="左右手" :required="isEditMode">
          <template #input>
            <van-radio-group v-model="leftRightHand" direction="horizontal">
              <van-radio name="0">右手</van-radio>
              <van-radio name="1">左手</van-radio>
              <van-radio name="2">双手</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-if="!isEditMode" v-model="enums.bowlerKickType[bowlerInfo.matchBowlerKickType]"
          :required="isEditMode" label="打球类型" :readonly="!isEditMode" />
        <van-field v-if="isEditMode" label="打球类型" :required="isEditMode">
          <template #input>
            <van-radio-group v-model="matchBowlerKickType" direction="horizontal">
              <van-radio name="0">直线</van-radio>
              <van-radio name="1">曲线</van-radio>
              <van-radio name="2">飞碟</van-radio>
            </van-radio-group>
          </template>
        </van-field>


      </van-cell-group>

      <div class="button-section">
        <van-button v-if="!isEditMode" round block type="primary" class="action-button"
          @click="goEditMode">修改信息</van-button>
        <div v-if="isEditMode" class="edit-buttons">
          <van-button round block type="primary" class="action-button submit-button"
            @click="submitBowlerInfo">提交</van-button>
          <van-button round block type="default" class="action-button cancel-button" @click="cancelEdit">取消</van-button>
        </div>

      </div>

      <van-popup v-model:show="showBirthDatePicker" position="bottom" class="date-picker-popup" :round="true">
        <van-date-picker v-model="currentDate" title="选择生日" type="date" :min-date="new Date(1940, 0, 1)"
          :max-date="new Date()" @confirm="onConfirmBirthDate" @cancel="showBirthDatePicker = false" />
      </van-popup>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import store from '@/store/index.js';
import env from '@/global/env';
import account from '@/api/account';
import bowler from '@/api/user';
import util from '@/global/util';
import { Toast, DatePicker, Popup, Field } from 'vant';
import { showToast } from 'vant';
import { Radio, RadioGroup } from 'vant';
import user from '@/global/user';
import logger from '@/global/logger';

import enums from '@/api/enums';

const isEditMode = ref(false);
const router = useRouter();
const showBirthDatePicker = ref(false);

const bowlerInfo = ref({
  avatar: null,
  name: '用户名',
  birthDate: ''
});
const currentDate = ref([]);

const gender = ref('');
const leftRightHand = ref('');
const matchBowlerKickType = ref('');

const fetchBowlerInfo = async () => {
  try {
    bowlerInfo.value = await bowler.getMyBowlerInfo();
    if (bowlerInfo.value.birthDate) {
      bowlerInfo.value.birthDate = util.formatDate(bowlerInfo.value.birthDate);
      currentDate.value = util.formatDateArray(bowlerInfo.value.birthDate)
    }
    if (!util.isBlank(bowlerInfo.value.gender)) {
      gender.value = bowlerInfo.value.gender.toString();
    }
    if (!util.isBlank(bowlerInfo.value.leftRightHand)) {
      leftRightHand.value = bowlerInfo.value.leftRightHand.toString();
    }
    if (!util.isBlank(bowlerInfo.value.matchBowlerKickType)) {
      matchBowlerKickType.value = bowlerInfo.value.matchBowlerKickType.toString();
    }
    logger.debug(bowlerInfo.value);
  }
  catch (error) {
    Toast.fail('获取用户信息失败,' + error);
  }
};

onMounted(async () => {
  await user.checkAuth();
  fetchBowlerInfo();
});

const onClickLeft = () => {
  router.push('/');  // 返回主页
  // 通过store设置激活的tab
  store.commit('setActiveTab', 1);  // 1 代表"我的"tab
}

const goEditMode = () => {
  isEditMode.value = true;
}

const cancelEdit = () => {
  isEditMode.value = false;
  // 重新获取数据，放弃所有更改
  fetchBowlerInfo();
}

const submitBowlerInfo = async () => {
  try {
    bowlerInfo.value.gender = parseInt(gender.value);
    bowlerInfo.value.leftRightHand = parseInt(leftRightHand.value);
    bowlerInfo.value.matchBowlerKickType = parseInt(matchBowlerKickType.value);
    await bowler.updateMyBowlerInfo(bowlerInfo.value);
    showToast({
      message: '保存成功',
      position: 'top',
      className: 'custom-toast'
    });
    isEditMode.value = false;
  } catch (error) {
    showToast({
      message: '保存失败：' + error.message,
      type: 'fail',
      position: 'top',
      className: 'custom-toast'
    });
  }
}

const onConfirmBirthDate = (value) => {
  if (!isEditMode.value) return;
  let vDate = util.formatDate(currentDate.value);
  bowlerInfo.value.birthDate = vDate;
  showBirthDatePicker.value = false;
}
</script>

<style scoped>
.container {
  position: relative;
  height: 100vh;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}


.fixed-header {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.content-section {
  padding: 0.427rem;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* 增加 iOS 滚动惯性 */
}

.info-card {
  background: white;
  border-radius: 0.427rem;
  margin-bottom: 0.427rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.van-field) {
  padding: 0.427rem 0.533rem;
}

:deep(.van-field__label) {
  color: #2c3e50;
  font-weight: 500;
  width: 4em;
}

:deep(.van-radio-group) {
  display: flex;
  gap: 0.533rem;
}

:deep(.van-radio__label) {
  color: #2c3e50;
}

:deep(.van-radio__icon .van-icon) {
  border-color: #3498db;
}

:deep(.van-radio__icon--checked .van-icon) {
  background-color: #3498db;
  border-color: #3498db;
}

.button-section {
  padding: 0.533rem;
  margin-top: 0.533rem;
  position: sticky;
  bottom: 0;
  background-color: #f5f7fa;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}

.edit-buttons {
  display: flex;
  gap: 0.427rem;
  max-width: 14rem;
  margin: 0 auto;
}

.submit-button {
  flex: 1;
  height: 1.333rem;
  font-size: 0.427rem;
  font-weight: 500;
  background: linear-gradient(135deg, #3498db, #2980b9);
  border: none;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
  border-radius: 0.667rem;
  min-width: 2rem;
}

.cancel-button {
  flex: 1;
  height: 1.333rem;
  font-size: 0.427rem;
  font-weight: 500;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  border-radius: 0.667rem;
  min-width: 2rem;
}

.cancel-button:active {
  background: #f5f7fa;
  border-color: #c0c4cc;
}

:deep(.action-button.van-button--primary:active) {
  background: linear-gradient(135deg, #2980b9, #2472a4);
}

/* 日期选择器弹出层样式 */
.date-picker-popup {
  border-radius: 0.427rem 0.427rem 0 0;
}

:deep(.van-picker__toolbar) {
  border-bottom: 1px solid #ebedf0;
}

:deep(.van-picker__title) {
  color: #2c3e50;
  font-weight: 600;
}

:deep(.van-picker__confirm) {
  color: #3498db;
}

:deep(.van-picker__cancel) {
  color: #95a5a6;
}

:deep(.van-picker-column__item--selected) {
  color: #3498db;
  font-weight: 500;
}
</style>